import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrVitaleIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M2.30078 2.9998C2.30078 2.06092 3.0619 1.2998 4.00078 1.2998H12.0008C12.9397 1.2998 13.7008 2.06092 13.7008 2.9998V11.4158C13.7008 11.9094 13.4862 12.3786 13.1129 12.7015L10.6272 14.8515C10.3183 15.1186 9.92353 15.2657 9.51511 15.2657H4.00078C3.0619 15.2657 2.30078 14.5046 2.30078 13.5657V2.9998ZM4.00078 2.6998C3.8351 2.6998 3.70078 2.83412 3.70078 2.9998V5.68789H12.3008V2.9998C12.3008 2.83412 12.1665 2.6998 12.0008 2.6998H4.00078ZM12.3008 7.08789H3.70078V13.5657C3.70078 13.7314 3.8351 13.8657 4.00078 13.8657H9.51511C9.58718 13.8657 9.65685 13.8397 9.71136 13.7926L12.197 11.6427C12.2629 11.5857 12.3008 11.5029 12.3008 11.4158V7.08789Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrVitaleIconComponent;
